import { useEffect, useRef, useState } from "react";
import Temp1 from '../Images/Header.jpg';
import Temp2 from '../Images/Header2.jpg';
import Temp3 from '../Images/Header3.jpg';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material';


const theme = createTheme({
    palette: {
        primary: {
            main: "#F61832", // custom primary color
        },
        secondary: {
            main: "#C13E39", // custom secondary color
        },
    },
});

export default function Header() {
  const headerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = [
    {
      image: Temp1,
      title: "Experience the best",
      description: "Unbeatable quality",
      cta: "Shop Now"
    },
    {
      image: Temp2,
      title: "Transform your product",
      description: "Print like a pro",
      cta: "Explore"
    },
    {
      image: Temp3,
      title: "Stick with the best",
      description: "",
      cta: "Grab Yours"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
<header
  ref={headerRef}
  className="relative w-full h-auto"
  style={{ aspectRatio: '1920/400' }}
>
  {/* Background Slideshow - FULL SCREEN VERSION */}
  <div className="absolute inset-0 z-0 overflow-hidden">
    {slides.map((slide, index) => (
      <div
        key={`bg-${index}`}
        className={`absolute inset-0 transition-opacity duration-1000 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`}
      >
        <img
          src={slide.image}
          alt={`Background ${index + 1}`}
          className="w-full h-full object-contain"
        />
        <div className="absolute inset-0 bg-black/30"></div>
      </div>
    ))}
  </div>

  {/* Content Container */}
  <div className="relative z-10 w-full h-full flex flex-col items-center justify-center p-6 md:p-8">
    {slides.map((slide, index) => (
      <div 
        key={`content-${index}`}
        className={`absolute flex flex-col items-center text-center transition-opacity duration-1000 max-w-4xl px-4 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`}
      >
        <div>
          <h1 className="text-xl md:text-4xl lg:text-6xl font-bold lg:mb-4 text-white [text-shadow:_3px_3px_5px_rgba(0,0,0,0.5)]">
            {slide.title}
          </h1>
        </div>
        <div>
          <h3 className="text-xl md:text-xl font-bold text-white lg:mb-6 [text-shadow:_2px_2px_4px_rgba(0,0,0,0.5)]">
            {slide.description}
          </h3>
        </div>
        <div>
          <ThemeProvider theme={theme}>
            <Button color="primary" variant="contained" size="large">
              {slide.cta}
            </Button>
          </ThemeProvider>
        </div>
      </div>
    ))}
  </div>
</header>
  );
}